class TreatmentHeroFilterReset extends window.BAO.CustomElement({
  SuperClass: HTMLButtonElement,
}) {
  setupListeners () {
    super.setupListeners()

    this.filterButtons = this.externalEls.filter.elements || []

    this.filterButtons.forEach(el => {
      this.listeners.add(el, 'click', this.handleFilterClick.bind(this))
    })

    this.listeners.add(this, 'click', this.handleClick.bind(this))
  }

  handleClick () {
    const resetButtonEl = document.querySelector(this.resetButtonSelector)

    if (resetButtonEl) {
      resetButtonEl.click()
    }

    this.setAttribute('data-clicked', 'true')

    this.scrollToProductGrid()
  }

  handleFilterClick () {
    this.removeAttribute('data-clicked')
  }

  scrollToProductGrid () {
    const productGridEl = document.querySelector(this.productGridSelector)

    if (!productGridEl) return

    const offset = 20
    const elementTop = productGridEl.getBoundingClientRect().top
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop

    window.scrollTo({
      top: elementTop + scrollTop - offset,
      behavior: 'smooth',
    })
  }

  get resetButtonSelector () {
    return `[data-treatment-hero-filter-reset-external-el="reset-button"]`
  }

  get productGridSelector () {
    return `[data-treatment-hero-filter-reset-external-el="products"]`
  }
}

if (!customElements.get('treatment-hero-filter-reset')) {
  customElements.define(
    'treatment-hero-filter-reset',
    TreatmentHeroFilterReset,
    {
      extends: 'button',
    },
  )
}
